module.exports = __webpack_public_path__ + "static/img/Doctor Profile.c17c318.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctors/Doctor Profile.svg
// module id = Qg4b
// module chunks = 7